<template>
    <div>
        <!-- Modal -->
        <div
            class="modal fade"
            :class="{ show: isVisible, 'd-block': isVisible }"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalMessage }}</h5>
                        <button
                            type="button"
                            class="close"
                            @click="closeModal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-footer">
                        <template v-if="modalLink">
                            <button
                                type="button"
                                class="btn btn-success"
                                @click="handleGoClick
"
                            >
                                {{ modalPrintButtonText }}
                            </button>
                        </template>
                        <template>
                            <button
                                type="button"
                                class="btn btn-danger"
                                @click="closeModal"
                            >
                                Cancel
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- Backdrop -->
        <div
            v-if="isVisible"
            class="modal-backdrop fade show"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'NestedBookingExistModal',
    props: {
        actionType: {
            type: String,
            default: 'receive'
        },
        nestedBooking: {
            type: Object,
            default: {}
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isVisible: this.visible,
        }
    },
    computed: {
        modalPrintButtonText() {
            if (!this.nestedBooking) return '';
            return `Print new label for #B-${this.nestedBooking.original_booking_id}-${this.nestedBooking.copy}`;
        },
        modalMessage() {
            if (!this.nestedBooking) return '';
            if (this.actionType === 'receive') {
                return "The booking has been copied.";
            }

            return `#B-${this.nestedBooking.original_booking_id} has been copied. Please print a new label for the latest booking in order to move the goods`;
        },
        modalLink() {
            if (!this.nestedBooking) return '';

            if (this.actionType === 'receive') {
                return `/receive-colli?nested_booking_id=` +  this.nestedBooking.id;
            }

            return null;
        }
    },

    watch: {
        visible(newValue) {
            this.isVisible = newValue;
        }
    },
    methods: {
        closeModal() {
            this.isVisible = false;
            this.$emit('close');
        },
        handleGoClick() {
            window.location.href = this.modalLink;
        }
    }
}
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
